export default __webpack_public_path__ + "static/media/7.9d7daf88.wav";